/**
 * Functionality (permission) codes. Must match nodeapp/src/database/functionalities.ts.
 * The backend enforces them; the web app uses them to shape menus and routes (route data.fncodes).
 * Add codes here as new portal screens are built.
 */
export const FN = {
  /** Employees: details, portal role, active flag and access to each application. */
  USERS_MANAGE: 'USERS_MANAGE',
} as const;

export type FnCode = (typeof FN)[keyof typeof FN];
